import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=73e893fe&scoped=true"
import script from "./RelatedArticles.vue?vue&type=script&lang=js"
export * from "./RelatedArticles.vue?vue&type=script&lang=js"
import style0 from "./RelatedArticles.vue?vue&type=style&index=0&id=73e893fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e893fe",
  null
  
)

export default component.exports